module.exports = __webpack_public_path__ + "38a6de35ca053539cd6d95d51978baa5.mp3";